import type { DevicePlatform } from '@ghostscreen/contracts';
import { formatDevicePlatform } from '../../lib/device/formatDevicePlatform';

type PlatformPillProps = {
  platform: DevicePlatform;
};

/** Identity badge for fleet rows — not a connection status. */
export function PlatformPill({ platform }: PlatformPillProps) {
  return (
    <span className="inline-flex items-center rounded-full border border-line bg-canvas px-2.5 py-1 text-[11.5px] font-semibold text-muted">
      {formatDevicePlatform(platform)}
    </span>
  );
}
